import React, { useState } from 'react'
import { Button } from 'antd'
import { FileText } from 'lucide-react'
import { PurchaseOrderDrawer } from '../../PurchaseOrders/PurchaseOrderDrawer'

export const PurchaseOrdersButton = () => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Button
        icon={<FileText className="h-4 w-4" />}
        onClick={() => setOpen(true)}
        block
      >
        Purchase Orders
      </Button>

      <PurchaseOrderDrawer open={open} onClose={() => setOpen(false)} />
    </>
  )
}
